import React from "react";
import { Link } from "react-router-dom";
import classes from "./affiliateDisclosure.module.css";
// @ts-ignore
import mergeClassNames from "merge-class-names";

export type DisclosureVariant = "chip" | "inline" | "block";

interface AffiliateDisclosureProps {
  variant?: DisclosureVariant;
  className?: string;
}

/**
 * Nhãn minh bạch cho link tiếp thị liên kết. Nói thẳng chuyện có hoa hồng làm
 * tăng độ tin chứ không giảm — đây là chuẩn của KOC Việt Nam, và cũng là yêu
 * cầu của cả Google lẫn quy định quảng cáo.
 */
function AffiliateDisclosure(props: AffiliateDisclosureProps) {
  const { variant = "chip", className = "" } = props;

  if (variant === "chip") {
    return (
      <span
        className={mergeClassNames(classes.chip, className)}
        title="Đây là link tiếp thị liên kết. Bạn không phải trả thêm đồng nào."
      >
        Tiếp thị liên kết
      </span>
    );
  }

  if (variant === "inline") {
    return (
      <p className={mergeClassNames(classes.inline, className)}>
        Bài viết có chứa link tiếp thị liên kết. Nếu bạn mua qua link, mình nhận
        được một khoản hoa hồng nhỏ — bạn không phải trả thêm đồng nào.{" "}
        <Link to="/privacy#affiliate" className={classes.link}>
          Tìm hiểu thêm
        </Link>
      </p>
    );
  }

  return (
    <div className={mergeClassNames(classes.block, className)}>
      <p className={classes.blockTitle}>Về các link ở trang này</p>
      <p className={classes.blockText}>
        Đây đều là đồ mình đã dùng thật và các link bên dưới là link tiếp thị
        liên kết Shopee. Nếu bạn mua qua đó, mình nhận được một khoản hoa hồng
        nhỏ từ Shopee —{" "}
        <strong>giá bạn trả không thay đổi, không hề đắt hơn</strong>. Mình chỉ
        giới thiệu đồ mình thực sự dùng và giữ nguyên cả nhược điểm trong phần
        nhận xét.{" "}
        <Link to="/privacy#affiliate" className={classes.link}>
          Chi tiết
        </Link>
      </p>
    </div>
  );
}

export default AffiliateDisclosure;
